// Shared with BE. Any change here must be mirrored in the backend's
// Services.Blog reserved-slug guard so blog slugs can never collide
// with a static route, a real asset, or a known S3 object.
const RESERVED_SLUGS = new Set([
  "contact-us",
  "ai-risk",
  "privacy-policy",
  "terms-and-conditions",
  "blog",
  "static",
  "assets",
  "favicon.ico",
  "manifest.json",
  "robots.txt",
  "sitemap.xml",
  "logo192.png",
  "logo512.png",
  "index.html",
  "asset-manifest.json",
]);

export function isReservedSlug(slug) {
  if (!slug) return true;
  if (slug.startsWith(".") || slug.startsWith("_")) return true;
  return RESERVED_SLUGS.has(slug);
}

export default RESERVED_SLUGS;
